<template>
  <div>
    <div class="wrapper">
      <h1>
        <font-awesome-icon :icon="['fas', 'handshake']" />
        Partner Opportunities
      </h1>
      <p class="lede">
        Let us help you track improvement in the people you help to grow. Our partnership is a perfect complement with
        one-on-one training to enterprise-wide cultural engagement activities.
      </p>
      <div class="pure-g">
        <div class="pure-u-1-4">
          <a href="#" id="managers">Managers</a>
          <p>Boost your team's<br />presentation talent IQ.</p>
        </div>
        <div class="pure-u-1-4">
          <a href="#" id="coaches">Executive Coaches</a>
          <p>Give your clients<br />even more value.</p>
        </div>
        <div class="pure-u-1-4">
          <a href="#" id="companies">Presentation Companies</a>
          <p>Track the training<br />results of your participants.</p>
        </div>
        <div class="pure-u-1-4">
          <a href="#" id="organizations">Organizations</a>
          <p>Drive empowerment<br />in your employees.</p>
        </div>
      </div>
      <p style="text-align: center">
        <br /><br />
        <a class="pure-button button-warning button-xlarge" href="mailto:support@torchmetrics.com">
          Contact Us for Information
        </a>
      </p>
    </div>
    <SubFooter />
  </div>
</template>

<script>
import SubFooter from "@/components/common/SubFooter"

export default {
  name: "Partners",
  components: { SubFooter }
}
</script>

<style lang="less" scoped>
.pure-u-1-4 {
  margin-top: 3em;
  text-align: center;

  a {
    display: block;
    font-size: 1.33em;
    font-weight: bold;
    text-decoration: none;
    transition: all .2s ease-in-out;

    &#managers { color: #5AC5C6; }
    &#coaches { color: #FFAF10; }
    &#companies { color: #EF765B; }
    &#organizations { color: #02C7CE; }

    &:hover {
      /* transform: scale(1.07); */
    }
  }

  p {
    font-weight: 300;
    margin-top: .5em;
  }
}
</style>